import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

export interface DownloadListItem {
    img: string;
    url: string;
}
@Component
export default class EpicDownloadGuide extends Vue {
    @Prop({ default: 'GET RIFO APP FOR FREE' })
    public title!: string;

    @Prop({ default: 'SAVE TIME | SAVE MONEY | LESS WORRIES' })
    public subTitle!: string;

    @Prop({ default: function() {
        return [{
            img: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-download/download-android.png',
            url: 'https://play.google.com/store/apps/details?id=ca.rifo.app'
        }, {
            img: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-download/download-app.png',
            url: 'https://apps.apple.com/ca/app/realjaja-pro/id1387717578'
        }];
    } })
    public downloadList!: DownloadListItem[];

    @Prop({ default: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-download/snapshot.png' })
    public snapshot!: string;
}
